<template>
  <div class="receipt-view" v-if="isShow" id="printArea">
    <receipt-view-single
      :id="'printArea-'+cIdx"
      class="print-area"
      v-for="(cp,cIdx) in copies"
      :key="cIdx"
      :copyName="cp"
      :agentName="agentName"
      :stampName="stampName"
      :model="model" />
  </div>
</template>

<script>
import ReceiptViewSingle from './ReceiptViewSingle.vue'
export default {
  name: 'project-register-receipt-view',
  components: {
    ReceiptViewSingle
  },
  props: {
    isShow: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => {
        return {
          industryId: null,
          cityId: null,
          method: 0, // 存储方式：0-保函|1-现金
          orderNumber: null,
          serialNo: null,
          projectName: null,
          projectSite: null,
          projectStruc: null,
          projectScale: null,
          projectCost: 0,
          projectStartDate: null,
          projectEndDate: null,
          daterange: null,
          duration: null,
          ownerName: null,
          ownerManager: null,
          ownerManagerTel: null,
          contractorName: null,
          contractorManager: null,
          contractorManagerTel: null,
          payableBase: 0,
          payableAmount: 0,
          payableRatio: 2,
          opName: null,
          opTel: null,
          supervisorName: null,
          guarantorName: null,
          guarantorAddress: null,
          guarantorContact: null,
          guarantorTel: null,
        }
      }
    }
  },
  data () {
    return {
      contentHtml: null,
      copies: [
        '第一联 监管单位留存',
        '第二联 经办机构留存',
        '第三联 存储单位留存',
      ],
      agents: [
        '焦作市劳动保障监察支队',
        '孟州市人力资源和社会保障局',
        '修武县人力资源和社会保障局',
        '温县劳动保障监察大队',
        '博爱县劳动监察大队',
      ],
      agentName: '焦作市劳动保障监察支队',
      stampName: '监管单位公章',
      thirdSheetName: '焦作市劳动保障监察支队'
    }
  },
  watch: {
    isShow: function (newVal) {
      if (newVal) {
        this.procThirdSheet()
      }
    }
  },
  mounted () {
    this.procThirdSheet()
  },
  methods: {
    procThirdSheet () {
      if (this.model.supervisorName) {
        let prefix = this.model.supervisorName
        switch (prefix) {
          case '孟州市人力资源和社会保障局':
            this.agentName = this.agents[1]
            this.stampName = this.agentName + '公章'
            this.thirdSheetName = this.agentName
            this.copies[2] = '第三联 ' + this.agentName + '留存'
            break
          case '修武县人力资源和社会保障局':
            this.agentName = this.agents[2]
            this.stampName = this.agentName + '公章'
            this.thirdSheetName = this.agentName
            this.copies[2] = '第三联 ' + this.agentName + '留存'
            break
          case '温县劳动保障监察大队':
            this.agentName = this.agents[3]
            this.stampName = this.agentName + '公章'
            this.thirdSheetName = this.agentName
            this.copies[2] = '第三联 ' + this.agentName + '留存'
            break
          case '博爱县劳动监察大队':
            this.agentName = this.agents[4]
            this.stampName = this.agentName + '公章'
            this.thirdSheetName = this.agentName
            this.copies[2] = '第三联 ' + this.agentName + '留存'
            break
          case '焦作市劳动保障监察支队':
            this.agentName = this.agents[0]
            this.stampName = this.agentName + '公章'
            this.thirdSheetName = this.agentName
            this.copies[2] = '第三联 ' + this.agentName + '留存'
            break
          default:
            this.agentName = '焦作市劳动保障监察支队'
            this.stampName = '焦作市劳动保障监察支队公章'
            this.thirdSheetName = '焦作市劳动保障监察支队'
            this.copies[2] = '第三联 ' + this.thirdSheetName + '留存'
            break
        }
      }
    }
  }
}
</script>

<style lang="less">
.receipt-view {

}
.print-area {
  width: 1188px;
}
</style>
